import request from '@/utils/request'


// 我的代办
export function getwddb(data) {
  return request({
    method: "post",
    url: "/yzdservice/api/enterprise/sydbrw/list",
    data: data
  })
}

// 业务申请
export function getywsq() {
  return request({
    method: "get",
    url: "/yzdservice/enterprise/yzddw/getYwsqXgxx"
  })
}
//判断单位审核状态
export function getLoginDwZt() {
  return request({
    method: "get",
    url: "/yzdservice/enterprise/yzddw/getLoginDwZt"
  })
}
